export const TOKEN_STORAGE_KEY = 'auth_token'

// Helper to get token from storage
export function getStoredToken(): string | null {
  return localStorage.getItem(TOKEN_STORAGE_KEY)
}

// Helper to clear stored token
export function clearStoredToken(): void {
  localStorage.removeItem(TOKEN_STORAGE_KEY)
}
